import { render, staticRenderFns } from "./plantilla_listado.vue?vue&type=template&id=1266ec23&"
import script from "./plantilla_listado.vue?vue&type=script&lang=js&"
export * from "./plantilla_listado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports